export const TRANSLATION_KEYS = {
    Heading: "solutionPage.deleteDialog.heading",
    SecondaryHeading: "solutionPage.deleteDialog.secondaryHeading",
    ConfirmText: "common.deleteText",
    DismissText: "common.dismissText"
};